//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import appConfig from '../../../../config/app-config';
import oldRoute from '../../../router/oldRoute';

function isSamePath(configPath, realPath) {
    return configPath === realPath
        || oldRoute[configPath] === realPath
}

export default {
    name: 'foot-bar',
    props: {
        tabs: Array, //菜单列表 [{url, icon, title}]
    },
    watch: {
        '$route': {
            immediate: true,
            handler(iroute) {
                const { path } = iroute;
                var index = this.tabs.findIndex(tab => {
                    const { url, menuid } = tab;
                    var routes = this.$router.options.routes.find(route => {
                        if (url && isSamePath(url.split('?')[0], route.path) && Number(this.$route.query.menuid) === menuid) {
                            return route;
                        }
                    })
                    if (routes && isSamePath(path, routes.path)) return true
                    return routes && routes.children && this.getChildrenPath(routes.children, path)
                })
                if (index > -1) this.setBarIndex(index)

            }
        }
    },
    methods: {
        goTab() {
            const tab = this.tabs[this.barIndex]
            if (tab) {
                const { url } = tab
                this.$router.push('/blank')
                setTimeout(() => {
                    if (url[0] !== '/') this.$x.locationReplace(url)
                    else this.$router.replace({ path: url, query: tab.flags })
                }, 10)
            }
        },
        setBarIndex(index) {
            this.$store.dispatch('setBarIndex', index)
        },
        getChildrenPath(routes, path) {
            return routes.find(route => {
                return route.children ? this.getChildrenPath(route.children, path) : route.path === path
            });
        },
        getIconCls(icon, isActive) {
            if (!icon) icon = 'van-icon-description'
            if (icon.indexOf('van-') === 0) { //支持vant图标
                return 'van-icon ' + icon
            }
            //嘉扬提供的icon
            return 'kyi-' + icon + (isActive ? '_active' : '')
        },
        getActiveColor() {
            if (appConfig.titleBg != this.$x.userInfo.titleBg) {
                return this.$x.userInfo.titleBg
            }
        }
    },
    computed: {
        ...mapGetters(['barIndex']),
        // textStyle() {
        //     var bg = this.$x.userInfo.footerBg
        //     if (bg) {
        //         var r = Number('0x' + bg.slice(0, 2))
        //         var g = Number('0x' + bg.slice(2, 4))
        //         var b = Number('0x' + bg.slice(4))
        //         if (r + g + b > 510)
        //             return '<style>.van-tabbar-item__text{color:#333}</style>'
        //     }
        //     return ''
        // },
    },

}
